module.exports = __webpack_public_path__ + "static/media/paper_facory_getty_tablet.d25a02c9.jpg";